module.exports = __webpack_public_path__ + "img/header-c.fdd9a39e.webp";